import React from "react";
import { useLocation } from "react-router-dom";
import ESModuleSubtopic from "../ESModuleSubtopic";

const ADCDAC = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || {
    subtopics: [],
    subjectPath: "",
  };

  return (
    <ESModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ADC DAC"
      videos={[
        "https://www.youtube.com/embed/fOf7G-Kjn2s",
        "https://www.youtube.com/embed/Ys_FMNcTzt4",
        "https://www.youtube.com/embed/TtAsMwhVcAs",
        "https://www.youtube.com/embed/3XjjUs8Cm7M",
        "https://www.youtube.com/embed/Pc1aFloxSMw",
      ]}
      takeaways={[]}
      questions={[
        "Discuss the working principle of ADC and analyze its importance in an embedded system with a real life scenario",
        "Mention at least three real life examples where digital to analog conversion is required. Design and illustrate R-2R ladder based DAC",
        "What is data acquisition system ? with neat block diagram explain the charecteristics applications and working principle of the following data converters: ADC- Analog to Digital Converter DAC – Digital to Analog Converter",
        "Explain the operation of an R-2R ladder DAC (Digital to Analog converter) in embedded systems when a 3-bit DAC is given an input value of Vref equal to 101 with a neat sketch."
      ]}
      exampleVideos={[]}
    />
  );
};

export default ADCDAC;
